import { gql } from '@apollo/client';
import { PLAYER_STATS_FRAGMENT } from '../../fragments';

export const GET_PLAYER_INFO = gql`
  ${PLAYER_STATS_FRAGMENT}
  query GetPlayerInfo($playerId: Int!, $currentSeasonId: Int!) {
    players(where: { id: { _eq: $playerId } }) {
      firstName
      lastName
      id
      position
      positionSecondary
      gbhpc
      rosters(where: { team: { season: { _eq: $currentSeasonId } } }) {
        team {
          id
          name
        }
      }
      attendance(where: { schedule: { seasonId: { _eq: $currentSeasonId } } }) {
        teamId
        schedule {
          awayGoalie
          awayScore
          awayShots
          awayTeam {
            id
            name
          }
          cancel
          date
          eng: goals(where: { en: { _eq: true } }) {
            teamId
          }
          goals {
            en
          }
          homeGoalie
          homeScore
          homeShots
          homeTeam {
            id
            name
          }
          id
          ot
          playoffs
          time
          goals_aggregate(where: { goal: { _eq: $playerId } }) {
            aggregate {
              count
            }
          }
          primaryAssists: goals_aggregate(
            where: { primaryAssist: { _eq: $playerId } }
          ) {
            aggregate {
              count
            }
          }
          secondaryAssists: goals_aggregate(
            where: { secondaryAssist: { _eq: $playerId } }
          ) {
            aggregate {
              count
            }
          }
          penalties_aggregate(where: { playerId: { _eq: $playerId } }) {
            aggregate {
              sum {
                minutes
              }
            }
          }
        }
      }
      skaterStats {
        ...PlayerStats
        seasonBySeason {
          id
          season
          year
          league
        }
        teamByTeam {
          id
          name
          captainPlayer {
            id
          }
          color
          colorSecondary
          champion
        }
      }
      careerStatsGoalie {
        id
        gamesPlayed
        win
        loss
        tie
        otl
        sol
        shotsAgainst
        goalsAgainst
        shutouts
        goals
        assists
        pim
        seasonBySeason {
          id
          season
          year
          league
        }
        teamByTeam {
          id
          name
          captainPlayer {
            id
          }
          color
          colorSecondary
          champion
        }
      }
    }
  }
`;
